import React from "react";
import { withRouter } from "react-router";
import classNames from "classnames";

import constants, { getRegPath } from "../../constants";

import Header from "./Header";
import SideContent from "./SideContent";
import Stepper from "../Stepper";

const RegistrationLayout = ({ children, location }) => {
  const showSideContent =
    location.pathname.startsWith(getRegPath("/auth")) ||
    constants.SHOW_SIDE_CONTENTS.map(i => getRegPath("/" + i)).includes(
      location.pathname
    );

  const showStepper = location.pathname.startsWith(getRegPath("/step3"));

  const isOverflow = location.pathname === getRegPath("/signup");

  return (
    <div className={"row mr-0"}>
      <div className={showSideContent ? "col-md-6" : "col-md-12"}>
        <Header showSideContent={showSideContent} />
        {showSideContent && (
          <div>
            <SideContent isOverflow={isOverflow} />
          </div>
        )}
      </div>
      <div className={classNames(showSideContent ? "col-md-6" : "col-md-12")}>
        {children}
      </div>
      {showStepper && (
        <div className="mx-auto">
          <Stepper />
        </div>
      )}
    </div>
  );
};

export default withRouter(RegistrationLayout);
